module.exports = new function menuInteractions ()
{

    const topMenu = document.querySelector('.top-navigation');
    const hamburger = document.querySelector('.hamburger');
    const overlayMenu = document.querySelector('.mobile-menu-overlay');
    const closeMenu = document.querySelector('.close-menu');
    const mainWrap = document.querySelector('.main');
    const navItems = document.querySelectorAll('.mobile-menu-overlay .menu-item');
    const breadcrumbs = document.querySelector('.breadcrumbs');


    // Add shadow to navbar on scroll.
    window.addEventListener('scroll', function(e)
    {
        e.preventDefault();

        let top = this.scrollY;
            top > 50 ? topMenu.classList.add('nav-shadow') : topMenu.classList.remove('nav-shadow')
    });


    // Open mobile overlay animation.
    hamburger.addEventListener('click', function()
    {
        overlayMenu.classList.add('show-menu');
        mainWrap.classList.add('slide-content-left');
        topMenu.classList.add('slide-content-left');

        // Check if breadcrumbs exists,
        // to prevent bug when clicking on pages that dont have breadcrumbs.
        breadcrumbs != null ? breadcrumbs.classList.add('slide-content-left') : 'do nothing';

        $('.mobile-menu-overlay .menu-item').each(function(i)
        {
            setTimeout(function()
            {
                $('.mobile-menu-overlay .menu-item').eq(i).addClass('slide-nav-items');
            }, 50 * ( i + 1 ));
        });
    });


    // Close mobile overlay animations.
    closeMenu.addEventListener('click', function()
    {
        $('.mobile-menu-overlay .menu-item').each(function(i)
        {
            setTimeout(function()
            {
                $('.mobile-menu-overlay .menu-item').eq(i).removeClass('slide-nav-items');
            }, 50 * ( i + 1 ));
        });

        // Set Timeout to give smoother transition on close.
        setTimeout(function()
        {
            overlayMenu.classList.remove('show-menu');
            mainWrap.classList.remove('slide-content-left');
            topMenu.classList.remove('slide-content-left');

            // Check if breadcrumbs exists,
            // to prevent bug when clicking on pages that dont have breadcrumbs.
            breadcrumbs != null ? breadcrumbs.classList.remove('slide-content-left') : 'do nothing';

        }, 300);
    });

}
